<template>
  <tbody>
  <tr :class="['clickable', {disabled: !entity.active,  updated: isLastVisited(entity.id) }]" @click="goToDetail($event, entity.id)">
    <td class="no_padding drag_drop"><span></span></td>
    <td class="no_padding">
      <input type="checkbox"
             :id="entity.id"
             :value="entity.id"
             @click.stop
             @change="onChange"
             :checked="isChecked"
      />
      <label
          :for="entity.id"
          @click.stop
          v-translate>Vybrat
      </label>
    </td>
    <td :data-th="'Název' | translate">
      <strong>{{ entity.name }}</strong>
    </td>
    <td :data-th="'Poskytovatel videa' | translate">
      <entity-link :id="entity.id_vod_provider" type="vodProvider">{{ entity.vod_provider_name }}</entity-link>
    </td>
    <td :data-th="'Počet videí' | translate">
      {{ entity.videos_count }}
    </td>
    <td :data-th="'Maximální počet videí' | translate">
      {{ maxVideoCount }}
    </td>
    <td :data-th="'Poskytováno od' | translate">
      {{ $_date_format(entity.provided_from) }}
    </td>
    <td :data-th="'Poskytováno do' | translate">
      {{ $_date_format(entity.provided_to) }}
    </td>
    <td :data-th="'Počet služeb' | translate">
      <span class="dotted" @click.stop="openServicesModal">
                {{ entity.services_count }}
        <modal ref="servicesmodalref">
          <div slot="title"><translate>Služby s balíčkem</translate> ({{ entity.services_count }})</div>
          <div slot="body">
            <ul>
              <li v-for="(item, index) in services" :key="index">{{ item.name }}</li>
            </ul>
          </div>
        </modal>
      </span>
    </td>
    <td></td>
  </tr>
  </tbody>
</template>

<script>
import rowActions from "../../mixins/row-actions";
import EntityLink from "../../common/EntityLink.vue";

export default {
  name: "VodPackagesRow",
  components: { EntityLink },
  mixins: [rowActions],
  props: {
    entity: Object,
  },
  data(){
    return{
      detailPageRouteName: "vodPackagesDetail",
      services: [],
    }
  },
  created(ServiceService) {
    this.serviceService = ServiceService
  },
  methods: {
    showServices() {
      this.$router.push({
        name: 'vodPackagesServices',
        params: {
          id: this.entity.id
        }
      });
    },
    showVideos() {
      this.$router.push({
        name: 'vodPackagesVideos',
        params: {
          id: this.entity.id
        }
      });
    },
    openServicesModal() {
      this.$refs.servicesmodalref.showModal(true)
      this.serviceService.getEntities({ vodPackageId: this.entity.id }).then(data => {
        this.services = data['services']
      })
    }
  },
  computed: {
    maxVideoCount(){
      return this.entity.maximum_number_of_videos ? this.entity.maximum_number_of_videos: this.$gettext('Neuvedeno');
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/vodPackages/VodPackagesRow.vue